<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    title="直接办结"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="40%"
    top="5%"
    append-to-body
    :close-on-click-modal="false"
  >
    <el-form :model="item" ref="itemform" label-width="150px" :rules="rules">
      <el-form-item label="办结说明" prop="FinishDesc">
        <el-input
          v-model.trim="item.FinishDesc"
          :autosize="{ minRows: 2 }"
          type="textarea"
          placeholder="请输入办结说明"
        ></el-input>
      </el-form-item>
      <el-form-item label="快递单号" prop="ExpressNumber">
        <el-input
          v-model.trim="item.ExpressNumber"
          placeholder="请输入快递单号"
        ></el-input>
      </el-form-item>
      <el-form-item label="收件人" prop="Addressee">
        <el-input
          v-model.trim="item.Addressee"
          placeholder="请输入收件人"
        ></el-input>
      </el-form-item>
      <el-form-item label="寄出日期" prop="SendingAt">
        <el-date-picker
          v-model="item.SendingAt"
          style="width: 100%"
          type="date"
          placeholder="选择日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="快递说明" prop="ExpressDesc">
        <el-input
          v-model.trim="item.ExpressDesc"
          :autosize="{ minRows: 2 }"
          type="textarea"
          placeholder="请输入快递说明"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      item: _.clone(this.value),
      rules: {
        FinishDesc: [
          { required: true, message: "办结说明不能为空", trigger: "blur" },
        ],
      },
      submitting: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  methods: {
    onOpen() {
      this.item = _.cloneDeep(this.value);
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        const itemData = {
          ...this.item,
        };
        this.$axios
          .request({
            url: "dci/maintain/register-finish",
            method: "post",
            data: itemData,
          })
          .then(() => {
            this.$message.success("办结成功");
            this.submitting = false;
            // this.$emit("form:created", true);
            this.$emit("form:saved", true);
            this.$emit("update:visible", false);
            this.$emit("cancel");
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.submitting = false;
          });
      });
    },
  },
};
</script>
